import React from 'react';
import PropTypes from 'prop-types';
import { useUID } from 'dibs-uid';
import HpLazyImageWrapper from '../HpLazyImageWrapper/HpLazyImageWrapper';
import ResponsiveImage from '../ResponsiveImage';

import styles from './HpRespHeroModuleItemOld.scss';

function HpRespHeroModuleItemOld({ item, isVisible, onClick, useLazyLoadImages }) {
    const { imageUrl, title, link } = item;
    const uid = useUID() || undefined;
    const heroModuleId = `heromodule-${uid}`;
    return (
        <a
            data-tn="hero-item-link"
            href={link}
            className={styles.heroItem}
            style={{ opacity: isVisible ? '1' : '0' }}
            onClick={onClick}
        >
            <HpLazyImageWrapper useLazyLoad={useLazyLoadImages} className={styles.imageWrapper}>
                <ResponsiveImage
                    ariaLabelledBy={heroModuleId}
                    className={styles.image}
                    src={imageUrl}
                    dataTn="hero-item-image"
                    srcSetWidths={[200, 240]}
                />
            </HpLazyImageWrapper>
            <div
                id={heroModuleId}
                className={styles.title}
                dangerouslySetInnerHTML={{ __html: title }}
                data-tn="hero-item-title"
            />
        </a>
    );
}

HpRespHeroModuleItemOld.propTypes = {
    item: PropTypes.shape({
        title: PropTypes.string,
        imageUrl: PropTypes.string,
        link: PropTypes.string,
    }).isRequired,
    isVisible: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    useLazyLoadImages: PropTypes.bool,
};

HpRespHeroModuleItemOld.defaultProps = {
    isVisible: true,
};

export { HpRespHeroModuleItemOld };
